import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map, throwError, catchError } from 'rxjs';
import { User } from './user';
import { newUser } from './newUser';
import { editUser } from './editUser';
import { newProject } from './newProject';
import { fileUpload } from './fileUpload';

@Injectable()
export class AuthService {
  newUserId: any;
  newProjId: any;
  newEventId: string | number | boolean | undefined;
  cellmessage: any;
  cellTwomessage: any;
  cellThreemessage: any;
  cellFourmessage: any;
  cellFivemessage: any;
  cellSixmessage: any;
  celltenmessage: any;
  celltenNewmessage: any;
  condId: string | number | boolean | undefined;
  newheatEff: { toString: () => string | number | boolean } | undefined;
  newcoolEff: { toString: () => string | number | boolean } | undefined;
  newOptionMsg: string | number | boolean | undefined;
  newcustValue: any;
  newvall: string | number | boolean | undefined;
  newpvValue: string | number | boolean | undefined;
  neweffValue: string | number | boolean | undefined;
  newwindValue: string | number | boolean | undefined;
  newinletTemp: string | number | boolean | undefined;
  newoutletTemp: string | number | boolean | undefined;
  newdhwSource: string | number | boolean | undefined;
  newefficency: string | number | boolean | undefined;
  newrequirement: string | number | boolean | undefined;
  newcustBaseRoof: any;
  newcustBaseFloor: any;
  newcustBaseWindow: any;
  newcustBaseShading: any;
  newcustBaseLighting: any;
  newcustBaseWwr: any;
  newcustDaylight: any;
  newToggleEditable: any;
  newisEditable: any;
  newAshNecb: any;
  newcustHvac: any;
  newcustHtRec: any;
  toggleStatusNew: string | number | boolean | undefined;
  toggleStatusNewWind: string | number | boolean | undefined;
  newIsUpdated: any;
  toggleStatusNewDhw: string | number | boolean | undefined;
  fval: any;
  message: string | undefined;
  proDat: any;
  wallone: any;
  roofone: any;
  florone: any;
  windone: any;
  shadone: any;
  ligtone: any;
  heatone: any;
  cellSevenmessage: any;
  cellEightmessage: any;
  cellNinemessage: any;
  combIdSelmessage: any;
  cellOption: any;
  custHeat: any;
  custHeatNew: any;
  custHvac: any;
  custDl: any;
  msgurl: string | undefined;
  firstLoginNew: any;
  editClientNew: string | number | boolean | undefined;
  newwwrVal: any;
  custNameNew:any;
  actualNameNew:any;

 rootDomainUrl  ='http://app.ecomatrix.io/';
 //rootDomainUrl  ='http://localhost/';
  //rootDomainUrl  = 'http://99.79.40.13/';
  testnew = 'hello';
  demoprjId = '220';

  rootUrl = this.rootDomainUrl + 'adeos/api/user_login.php';
  registerUserUrl = this.rootDomainUrl + 'adeos/api/add_user.php';
  editUserDetailsUrl = this.rootDomainUrl + 'adeos/api/edit_user.php';
  editUserUrl = this.rootDomainUrl + 'adeos/api/update_user_info.php';
  newurl = this.rootDomainUrl + 'adeos/api/projectdetails.php';
  chkUserUrl = this.rootDomainUrl + 'adeos/api/user_list.php';
  renewablesUrl = this.rootDomainUrl + 'adeos/api/renewables.php';
  freshAirUrl = this.rootDomainUrl + 'adeos/api/air_dhw.php';
  uploadUrl = this.rootDomainUrl + 'adeos/api/upload_renewables.php';
  buildenv = this.rootDomainUrl + 'adeos/api/builing_envelope.php';
  lighting = this.rootDomainUrl + 'adeos/api/lighting.php';
  hvac = this.rootDomainUrl + 'adeos/api/hvac.php';
  clientlist = this.rootDomainUrl + 'adeos/api/adeosclients.php';
  project = this.rootDomainUrl + 'adeos/api/adeosprojects.php?user_id=';
  addproject = this.rootDomainUrl + 'adeos/api/add_project.php';
  renewablesCostUrl = this.rootDomainUrl + 'adeos/api/renewables_cost.php';
  buildEnvCostUrl = this.rootDomainUrl + 'adeos/api/builing_envelope_cost.php';
  lightingCostUrl = this.rootDomainUrl + 'adeos/api/lighting_cost.php';
  hvacUrl = this.rootDomainUrl + 'adeos/api/hvac_cost.php';
  proEnergyUrl = this.rootDomainUrl + 'adeos/api/pro_energy_data.php';
  proSankUrl = this.rootDomainUrl + 'adeos/api/load_results.php';
  freshAirUrlNew = this.rootDomainUrl + 'adeos/api/fresh_air_list.php';
  updateHeatCool = this.rootDomainUrl + 'adeos/api/update_heat_cool.php';
  checkUpdateStatusUrl =
    this.rootDomainUrl + 'adeos/api/check_update_status.php';
  inf = this.rootDomainUrl + 'adeos/api/infiltration.php';
  infCostUrl = this.rootDomainUrl + 'adeos/api/infiltration_cost.php';
  kpiDataUrl = this.rootDomainUrl + 'adeos/api/kpi.php';
  tediOptionsDataUrl = this.rootDomainUrl + 'adeos/api/tedi.php';
  humDataUrl = this.rootDomainUrl + 'adeos/api/humidification.php';
  baselineDefnDataUrl = this.rootDomainUrl + 'adeos/api/baseline_definition.php';
  wizardSelectionDataUrl = this.rootDomainUrl + 'adeos/api/for_dashboard_chart_search_cost.php';
  catCustomDataUrl = this.rootDomainUrl + 'adeos/api/category_customization.php';

  demoid;
  newEmail: string | undefined;

  private loggedIn = new BehaviorSubject<boolean>(false); // {1}
  chekuser: any;

  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();

  private wwrVal = new BehaviorSubject(' ');
  currentwwrVal = this.wwrVal.asObservable();

  private cellOPtionMsg = new BehaviorSubject('Option1');
  currentMesgcellOPtionMsg = this.cellOPtionMsg.asObservable();

  private cellOneMsg = new BehaviorSubject('dgt msg');
  currentMesgcellOneMsg = this.cellOneMsg.asObservable();

  private cellTwoMsg = new BehaviorSubject('R1');
  currentMesgcellTwoMsg = this.cellTwoMsg.asObservable();

  private cellThreeMsg = new BehaviorSubject('F1');
  currentMesgcellThreeMsg = this.cellThreeMsg.asObservable();

  private cellFourMsg = new BehaviorSubject('WIN01');
  currentMesgcellFourMsg = this.cellFourMsg.asObservable();

  private cellFiveMsg = new BehaviorSubject('NO.SH');
  currentMesgcellFiveMsg = this.cellFiveMsg.asObservable();

  private cellSixMsg = new BehaviorSubject('LPD1');
  currentMesgcellSixMsg = this.cellSixMsg.asObservable();

  private cellSevenMsg = new BehaviorSubject('0.1');
  currentMesgcellSevenMsg = this.cellSevenMsg.asObservable();

  private cellEightMsg = new BehaviorSubject('DLOFF');
  currentMesgcellEightMsg = this.cellEightMsg.asObservable();

  private cellNineMsg = new BehaviorSubject('01_FCU');
  currentMesgcellNineMsg = this.cellNineMsg.asObservable();

  private cellTenMsg = new BehaviorSubject('YES');
  currentMesgcellTenMsg = this.cellTenMsg.asObservable();

  private cellTenNewMsg = new BehaviorSubject('YES');
  currentMesgcellTenNewMsg = this.cellTenNewMsg.asObservable();

  private combIdSel = new BehaviorSubject('');
  currentCombIdSel = this.combIdSel.asObservable();

  private userId = new BehaviorSubject(1);
  currentUserId = this.userId.asObservable();

  private clientName = new BehaviorSubject('Hello');
  currentClientName = this.clientName.asObservable();

  private chartBeCost = new BehaviorSubject('Yes');
  currenchartBeCost = this.chartBeCost.asObservable();

  private clientEmail = new BehaviorSubject('Hello');
  currentClientEmail = this.clientEmail.asObservable();

  private eventId = new BehaviorSubject(1);
  currenteventId = this.eventId.asObservable();

  private projId = new BehaviorSubject(1);
  currentprojId = this.projId.asObservable();

  private heatEff = new BehaviorSubject(0);
  currentheatEff = this.heatEff.asObservable();

  private coolEff = new BehaviorSubject(0);
  currentcoolEff = this.coolEff.asObservable();

  private optionMsg = new BehaviorSubject('ASHRAE');
  currentOptionMsg = this.optionMsg.asObservable();

  private custValue = new BehaviorSubject(' ');
  currentcustValue = this.custValue.asObservable();

  private pvValue = new BehaviorSubject(' ');
  currentpvValue = this.pvValue.asObservable();

  private effValue = new BehaviorSubject(' ');
  currenteffValue = this.effValue.asObservable();

  private windValue = new BehaviorSubject(' ');
  currentwindValue = this.windValue.asObservable();

  private inletTemp = new BehaviorSubject(' ');
  currentinletTemp = this.inletTemp.asObservable();

  private outletTemp = new BehaviorSubject(' ');
  currentoutletTemp = this.outletTemp.asObservable();

  private dhwSource = new BehaviorSubject(' ');
  currentdhwSource = this.dhwSource.asObservable();

  private efficency = new BehaviorSubject(' ');
  currentefficency = this.efficency.asObservable();

  private requirement = new BehaviorSubject(' ');
  currentrequirement = this.requirement.asObservable();

  private custBase = new BehaviorSubject(' ');
  currentcustBase = this.custBase.asObservable();

  private custBaseRoof = new BehaviorSubject(' ');
  currentcustBaseRoof = this.custBaseRoof.asObservable();

  private custBaseFloor = new BehaviorSubject(' ');
  currentcustBaseFloor = this.custBaseFloor.asObservable();

  private custBaseWindow = new BehaviorSubject(' ');
  currentcustBaseWindow = this.custBaseWindow.asObservable();

  private custBaseShading = new BehaviorSubject(' ');
  currentcustBaseShading = this.custBaseShading.asObservable();

  private custBaseLighting = new BehaviorSubject(' ');
  currentcustBaseLighting = this.custBaseLighting.asObservable();

  private custBaseInf = new BehaviorSubject(' ');
  currentcustBaseInf = this.custBaseInf.asObservable();

  private custBaseWwr = new BehaviorSubject(' ');
  currentcustBaseWwr = this.custBaseWwr.asObservable();

  private custBaseDaylight = new BehaviorSubject(' ');
  currentcustBaseDaylight = this.custBaseDaylight.asObservable();

  private ToggleEditable = new BehaviorSubject(' ');
  currentToggleEditable = this.ToggleEditable.asObservable();

  private AshNecb = new BehaviorSubject(' ');
  currentAshNecb = this.AshNecb.asObservable();

  private custBaseHvac = new BehaviorSubject(' ');
  currentcustBaseHvac = this.custBaseHvac.asObservable();

  private custBaseHtRec = new BehaviorSubject('Y');
  currentcustBaseHtRec = this.custBaseHtRec.asObservable();

  private toggleStatus = new BehaviorSubject('false');
  currentToggleStatus = this.toggleStatus.asObservable();

  private toggleStatusWind = new BehaviorSubject('false');
  currentToggleStatusWind = this.toggleStatusWind.asObservable();

  private isUpdated = new BehaviorSubject(0);
  currentisUpdated = this.isUpdated.asObservable();

  private toggleStatusDhw = new BehaviorSubject('false');
  currentToggleStatusDhw = this.toggleStatusDhw.asObservable();

  private firstLoginVal = new BehaviorSubject('T');
  currentFirstLoginVal = this.firstLoginVal.asObservable();

  private editClientVal = new BehaviorSubject('');
  currenteditClientVal = this.editClientVal.asObservable();

  private isEditable = new BehaviorSubject('false');
  currentisEditable = this.isEditable.asObservable();

  private isKpi = new BehaviorSubject(false);
  currentIskpi = this.isKpi.asObservable();

  private kpiFactors = new BehaviorSubject([]);
  currentkpiFactors = this.kpiFactors.asObservable();

  private showEnergy = new BehaviorSubject(false);
  currentShowEnergy = this.showEnergy.asObservable();
  
  private showTedi = new BehaviorSubject(false);
  currentShowTedi = this.showTedi.asObservable();

  private hideAxisArr = new BehaviorSubject([]);
  currenthideAxisArr = this.hideAxisArr.asObservable();
  combId: any;

  private actualName = new BehaviorSubject('');
  currentActualName = this.actualName.asObservable();

  private custName = new BehaviorSubject('');
  currentCustName = this.custName.asObservable();


  get isLoggedIn() {
    return this.loggedIn.asObservable(); // {2}
  }

  private enableUploadBtn = new BehaviorSubject<boolean>(false);
  get btnStatus() {
    return this.enableUploadBtn.asObservable(); // {2}
  }

  constructor(private router: Router, private http: HttpClient) {
    this.currentToggleStatusWind.subscribe(
      (toggleStatusNewWind: any) =>
        (this.toggleStatusNewWind = toggleStatusNewWind)
    );
    this.currentToggleStatus.subscribe(
      (toggleStatusNew: any) => (this.toggleStatusNew = toggleStatusNew)
    );
    this.currentrequirement.subscribe(
      (newrequirement: any) => (this.newrequirement = newrequirement)
    );
    this.currentefficency.subscribe(
      (newefficency: any) => (this.newefficency = newefficency)
    );
    this.currentdhwSource.subscribe(
      (newdhwSource: any) => (this.newdhwSource = newdhwSource)
    );
    this.currentoutletTemp.subscribe(
      (newoutletTemp: any) => (this.newoutletTemp = newoutletTemp)
    );
    this.currentinletTemp.subscribe(
      (newinletTemp: any) => (this.newinletTemp = newinletTemp)
    );
    this.currentwindValue.subscribe(
      (newwindValue: any) => (this.newwindValue = newwindValue)
    );
    this.currenteffValue.subscribe(
      (neweffValue: any) => (this.neweffValue = neweffValue)
    );
    this.currentpvValue.subscribe(
      (newpvValue: any) => (this.newpvValue = newpvValue)
    );
    this.currentwwrVal.subscribe(
      (newwwrVal: any) => (this.newwwrVal = newwwrVal)
    );
    this.currentcustValue.subscribe(
      (newcustValue: any) => (this.newcustValue = newcustValue)
    );
    this.currentOptionMsg.subscribe(
      (newOptionMsg: any) => (this.newOptionMsg = newOptionMsg)
    );
    this.currentMesgcellOneMsg.subscribe(
      (cellmessage: any) => (this.cellmessage = cellmessage)
    );
    this.currentMesgcellTwoMsg.subscribe(
      (cellTwomessage: any) => (this.cellTwomessage = cellTwomessage)
    );
    this.currentMesgcellThreeMsg.subscribe(
      (cellThreemessage: any) => (this.cellThreemessage = cellThreemessage)
    );
    this.currentMesgcellFourMsg.subscribe(
      (cellFourmessage: any) => (this.cellFourmessage = cellFourmessage)
    );
    this.currentMesgcellFiveMsg.subscribe(
      (cellFivemessage: any) => (this.cellFivemessage = cellFivemessage)
    );
    this.currentMesgcellSixMsg.subscribe(
      (cellSixmessage: any) => (this.cellSixmessage = cellSixmessage)
    );
    this.currentMesgcellSevenMsg.subscribe(
      (cellSevenmessage: any) => (this.cellSevenmessage = cellSevenmessage)
    );
    this.currentMesgcellEightMsg.subscribe(
      (cellEightmessage: any) => (this.cellEightmessage = cellEightmessage)
    );
    this.currentMesgcellNineMsg.subscribe(
      (cellNinemessage: any) => (this.cellNinemessage = cellNinemessage)
    );
    this.currentMesgcellTenMsg.subscribe(
      (celltenmessage: any) => (this.celltenmessage = celltenmessage)
    );
    this.currentMesgcellTenNewMsg.subscribe(
      (celltenNewmessage: any) => (this.celltenNewmessage = celltenNewmessage)
    );
    this.currentCombIdSel.subscribe(
      (combId: any) => (this.combIdSelmessage = combId)
    );
    this.currentUserId.subscribe(
      (newUserId: string | number) => (this.newUserId = newUserId)
    );
    this.currenteventId.subscribe(
      (newEventId: any) => (this.newEventId = newEventId)
    );
    this.currentprojId.subscribe(
      (newProjId: string | number | boolean) => (this.newProjId = newProjId)
    );
    this.currentheatEff.subscribe(
      (newheatEff: any) => (this.newheatEff = newheatEff)
    );
    this.currentcoolEff.subscribe(
      (newcoolEff: any) => (this.newcoolEff = newcoolEff)
    );
    this.currentisUpdated.subscribe(
      (newIsUpdated: any) => (this.newIsUpdated = newIsUpdated)
    );
    this.currentToggleStatusDhw.subscribe(
      (toggleStatusNewDhw: any) =>
        (this.toggleStatusNewDhw = toggleStatusNewDhw)
    );
    this.currentFirstLoginVal.subscribe(
      (firstLoginNew: any) => (this.firstLoginNew = firstLoginNew)
    );
    this.currenteditClientVal.subscribe(
      (editClientNew: any) => (this.editClientNew = editClientNew)
    );
    this.currentActualName.subscribe(
      (actualName: any) => (this.actualNameNew = actualName)
    );
    this.currentCustName.subscribe(
      (custName: any) => (this.custNameNew = custName)
    );
    this.currentMessage.subscribe((message: any) => (this.message = message));
    this.currentMesgcellOPtionMsg.subscribe(
      (cellOption: any) => (this.cellOption = cellOption)
    );

    this.currentcustBaseHtRec.subscribe(
      (custHeat: any) => (this.custHeat = custHeat)
    );

    this.currentcustBaseHvac.subscribe(
      (custHvac: any) => (this.custHvac = custHvac)
    );

    this.currentcustBaseDaylight.subscribe(
      (custDl: any) => (this.custDl = custDl)
    );

    this.currentClientEmail.subscribe(
      (newEmail: any) => (this.newEmail = newEmail)
    );


    if (this.message == 'default message') {
      this.demoid = '1';
    }
  }

  // load json file and create the chart
  gtvalFirst() {
    if (this.newUserId == 74) {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    if (this.newEmail == 'demo@ecomatrix.io') {
      this.msgurl =
        this.rootDomainUrl +
        'adeos/api/for_dashboard_chart_search.php?user_id=5' +
        '&proj_id=' +
        this.demoprjId +
        '&baseline=ASHRAE' +
        '&wall="W1","W2","W3","W4"' +
        '&roof="R1","R2","R3"' +
        '&floor="F1","F2"' +
        '&window="WIN02","WIN03","WIN05","WIN06"' +
        '&inf="INF1","INF2","INF3"' +
        '&shading="NO","YES"' +
        '&wwr="0.22","0.27","0.32"' +
        '&dl="DLON","DLOFF"' +
        '&hvac="' +
        encodeURIComponent('NG furnace with DX') +
        '","' +
        encodeURIComponent('Ele furnace with DX'.toString()) +
        '","' +
        encodeURIComponent('CP 1B_Ele Boilers & HR + CF Chillers'.toString()) +
        '","' +
        encodeURIComponent(
          'AWHP with ele backup'.toString()
        ) +
        '"&heatRecovery="Y","N"';
		this.addtoKpiList('eui');
		this.addtoKpiList('savings');
		this.addtoKpiList('tedi');
		this.changeToggleEditable('true');
		this.changeshowEnergy(true);
		this.changeshowTedi(true);
		
    } else {
      this.msgurl =
        this.rootDomainUrl +
        'adeos/api/for_dashboard_chart_search.php?user_id=' +
        this.condId +
        '&proj_id=' +
        this.newProjId +
        '&baseline=ASHRAE' +
        '&' +
        this.message;
    }
    this.http.get(this.msgurl).subscribe((data) => {
      this.proDat = data;
      var onesc = this.proDat.projLists.slice(0, 4);
      this.wallone = onesc[0].WALL;
      this.roofone = onesc[0].ROOF;
      this.florone = onesc[0].FLOOR;
      this.windone = onesc[0].WINDOW;
      this.shadone = onesc[0].SHADING;
      this.ligtone = onesc[0].INFILTRATION;
      this.combId = onesc[0].cID;
      if (onesc[0].HEAT == 'Y') {
        this.heatone = 'YES';
      }
      if (onesc[0].HEAT == 'N') {
        this.heatone = 'NO';
      }
    });
  }

  changeKpiList(kpis: any): void {
    this.kpiFactors.next(kpis);
  }
  addtoKpiList(newList: any) {
    const currentList = this.kpiFactors.value;
    const updatedList = currentList.concat(newList);
    this.kpiFactors.next(updatedList);
  }

  changewwrVal(newwwrVal: string) {
    this.wwrVal.next(newwwrVal);
  }

  cellOptionFn(cellOption: string) {
    this.cellOPtionMsg.next(cellOption);
  }
  changeisEditable(newisEditable: string) {
    this.isEditable.next(newisEditable);
  }
  changeisKpi(newisKpi: boolean) {
    this.isKpi.next(newisKpi);
  }
  changeshowEnergy(newshowEnergy: boolean) {
    this.showEnergy.next(newshowEnergy);
  }
  changeshowTedi(newshowTedi: boolean) {
    this.showTedi.next(newshowTedi);
  }
  changehideAxisArr(newHideArr: any) {
    this.hideAxisArr.next(newHideArr);
  }
  addtoHideArr(newList: any) {
    const currentList = this.hideAxisArr.value;
    const updatedList = currentList.concat(newList);
    this.hideAxisArr.next(updatedList);
  }
  changetoggleStatusWind(toggleStatusNewWind: string) {
    this.toggleStatusWind.next(toggleStatusNewWind);
  }

  changetoggleStatus(toggleStatusNew: string) {
    this.toggleStatus.next(toggleStatusNew);
  }

  changeAshNecb(newAshNecb: string) {
    this.AshNecb.next(newAshNecb);
  }

  changeToggleEditable(newToggleEditable: string) {
    this.ToggleEditable.next(newToggleEditable);
  }

  changecustBaseDaylight(newcustDaylight: string) {
    this.custBaseDaylight.next(newcustDaylight);
  }

  changecustBaseHvac(newcustHvac: string) {
    this.custBaseHvac.next(newcustHvac);
  }

  changecustBaseWwr(newcustBaseWwr: string) {
    this.custBaseWwr.next(newcustBaseWwr);
  }

  changecustBaseLighting(newcustBaseLighting: string) {
    this.custBaseLighting.next(newcustBaseLighting);
  }

  changecustBaseInf(newcustBaseInf: string) {
    this.custBaseInf.next(newcustBaseInf);
  }
  changecustBaseShading(newcustBaseShading: string) {
    this.custBaseShading.next(newcustBaseShading);
  }

  changecustBaseWindow(newcustBaseWindow: string) {
    this.custBaseWindow.next(newcustBaseWindow);
  }
  changecustBaseHtRec(newcustHtRec: string) {
    this.custBaseHtRec.next(newcustHtRec);
  }

  changecustBaseFloor(newcustBaseFloor: string) {
    this.custBaseFloor.next(newcustBaseFloor);
  }

  changecustBaseRoof(newcustBaseRoof: string) {
    this.custBaseRoof.next(newcustBaseRoof);
  }

  changecustBase(newcustBase: string) {
    this.custBase.next(newcustBase);
  }

  changerequirement(newrequirement: string) {
    this.requirement.next(newrequirement);
  }

  changeefficency(newefficency: string) {
    this.efficency.next(newefficency);
  }

  changedhwSource(newdhwSource: string) {
    this.dhwSource.next(newdhwSource);
  }

  changeoutletTemp(newoutletTemp: string) {
    this.outletTemp.next(newoutletTemp);
  }

  changeinletTemp(newinletTemp: string) {
    this.inletTemp.next(newinletTemp);
  }
  changewindValue(newwindValue: string) {
    this.windValue.next(newwindValue);
  }

  changeOptionMessage(newOptionMsg: string) {
    this.optionMsg.next(newOptionMsg);
  }

  changecustValue(newcustValue: string) {
    this.custValue.next(newcustValue);
  }

  changepvValue(newpvValue: string) {
    this.pvValue.next(newpvValue);
  }

  changeeffValue(neweffValue: string) {
    this.effValue.next(neweffValue);
  }

  changeeventId(newEventId: number) {
    this.eventId.next(newEventId);
  }
  changeprojId(newProjId: number) {
    this.projId.next(newProjId);
  }

  changeheatEff(newheatEff: number) {
    this.heatEff.next(newheatEff);
  }

  changecoolEff(newcoolEff: number) {
    this.coolEff.next(newcoolEff);
  }

  changeUserId(newUserId: number) {
    this.userId.next(newUserId);
  }

  changeMessage(message: string) {
    this.messageSource.next(message);
  }
  cellOneMessage(cellmessage: string) {
    this.cellOneMsg.next(cellmessage);
  }
  cellTwoMessage(cellTwomessage: string) {
    this.cellTwoMsg.next(cellTwomessage);
  }

  cellThreeMessage(cellThreemessage: string) {
    this.cellThreeMsg.next(cellThreemessage);
  }

  cellFourMessage(cellFourMessage: string) {
    this.cellFourMsg.next(cellFourMessage);
  }

  cellFiveMessage(cellFiveMessage: string) {
    this.cellFiveMsg.next(cellFiveMessage);
  }

  cellSixMessage(cellSixMessage: string) {
    this.cellSixMsg.next(cellSixMessage);
  }
  cellSevenMessage(cellSevenmessage: string) {
    this.cellSevenMsg.next(cellSevenmessage);
  }

  cellEightMessage(cellEightmessage: string) {
    this.cellEightMsg.next(cellEightmessage);
  }

  cellNineMessage(cellNinemessage: string) {
    this.cellNineMsg.next(cellNinemessage);
  }

  cellTenMessage(celltenmessage: string) {
    this.cellTenMsg.next(celltenmessage);
  }
  cellTenNewMessage(celltenNewmessage: string) {
    this.cellTenNewMsg.next(celltenNewmessage);
  }
  combIdSelMessage(combIdSel: string) {
    this.combIdSel.next(combIdSel);
  }

  newClientName(newCname: string) {
    this.clientName.next(newCname);
  }

  newchartBeCost(newChart: string) {
    this.chartBeCost.next(newChart);
  }

  newClientEmail(newEmail: string) {
    this.clientEmail.next(newEmail);
  }

  changeIsUpdated(newIsUpdated: any) {
    this.isUpdated.next(newIsUpdated);
  }

  changeToggleStatusDhw(toggleStatusNewDhw: any) {
    this.toggleStatusDhw.next(toggleStatusNewDhw);
  }

  changeFirstLoginVal(firstLoginNew: string) {
    this.firstLoginVal.next(firstLoginNew);
  }

  changeEditClientVal(editClientNew: any) {
    this.editClientVal.next(editClientNew);
  }
  changeActualName(actual: any) {
    this.actualName.next(actual);
  }
  changeCustName(cust: any) {
    this.custName.next(cust);
  }
  freshAirCalc() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    this.newvall = this.newcustValue;

    const bodynew = new HttpParams()
      .set('user_id', this.condId ? this.condId.toString() : '')
      .set('proj_id', this.newProjId.toString())
      .set('heatingEff', this.newheatEff ? this.newheatEff.toString() : '')
      .set('coolingEff', this.newcoolEff ? this.newcoolEff.toString() : '')
      .set('option', this.newOptionMsg ? this.newOptionMsg : '')
      .set('value', this.newvall ? this.newvall : '');

    return this.http
      .post(this.rootDomainUrl + 'adeos/api/fresh_air_calc.php', bodynew)
      .pipe(map((res: any) => res));
  }

  dhwCalc() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    let bodynew = null;
    if (this.newEmail == 'demo@ecomatrix.io') {
      bodynew = new HttpParams()
        .set('user_id', '5')
        .set('proj_id', this.demoprjId)
        .set('inletTemp', '10')
        .set('outletTemp', '60')
        .set('requirement', '2845')
        .set('DHWSource', 'Electricity')
        .set('efficiency', '100')
        .set('isSelected', 'true');
    } else if (this.newEmail !== 'demo@ecomatrix.io') {
      bodynew = new HttpParams()
        .set('user_id', this.condId ? this.condId.toString() : '')
        .set('proj_id', this.newProjId.toString())
        .set('inletTemp', this.newinletTemp ? this.newinletTemp : '')
        .set('outletTemp', this.newoutletTemp ? this.newoutletTemp : '')
        .set('requirement', this.newrequirement ? this.newrequirement : '')
        .set('DHWSource', this.newdhwSource ? this.newdhwSource : '')
        .set('efficiency', this.newefficency ? this.newefficency : '')
        .set(
          'isSelected',
          this.toggleStatusNewDhw ? this.toggleStatusNewDhw : ''
        );
    }

    if (!!bodynew) {
      return this.http
        .post(this.rootDomainUrl + 'adeos/api/dhw_calc.php', bodynew)
        .pipe(map((res: any) => res));
    } else {
      return {};
    }
  }

  solarPvCalc() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    let bodynew = {};
    if (this.newEmail == 'demo@ecomatrix.io') {
      bodynew = new HttpParams()
        .set('user_id', '5')
        .set('proj_id', this.demoprjId)
        .set('areaPV', '100')
        .set('eff', '19')
        .set('isSelected', 'false');
    } else if (this.newEmail !== 'demo@ecomatrix.io') {
      bodynew = new HttpParams()
        .set('user_id', this.condId ? this.condId.toString() : '')
        .set('proj_id', this.newProjId.toString())
        .set('areaPV', this.newpvValue ? this.newpvValue : '')
        .set('eff', this.neweffValue ? this.neweffValue : '')
        .set('isSelected', this.toggleStatusNew ? this.toggleStatusNew : '');
    }

    return this.http
      .post(this.rootDomainUrl + 'adeos/api/solar_pv_calc.php', bodynew)
      .pipe(map((res: any) => res));
  }

  windPowerCalc() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    let bodynew = {};
    if (this.newEmail == 'demo@ecomatrix.io') {
      bodynew = new HttpParams()
        .set('user_id', '5')
        .set('proj_id', this.demoprjId)
        .set('windPower', '0')
        .set('isSelected', 'false');
    } else if (this.newEmail !== 'demo@ecomatrix.io') {
      bodynew = new HttpParams()
        .set('user_id', this.condId ? this.condId.toString() : '')
        .set('proj_id', this.newProjId.toString())
        .set('windPower', this.newwindValue ? this.newwindValue : '')
        .set(
          'isSelected',
          this.toggleStatusNewWind ? this.toggleStatusNewWind : ''
        );
    }

    return this.http
      .post(this.rootDomainUrl + 'adeos/api/wind_power_calc.php', bodynew)
      .pipe(map((res: any) => res));
  }

  login(user: User) {
    const body = new HttpParams()
      .set('emailid', user.email)
      .set('pass', user.pwd);
    if (user.email !== '' && user.pwd != '') {
      // {3}
      return this.http.post(this.rootUrl, body).pipe(map((res: any) => res));
    }
    return false;
  }

  private _errorHandler(error: string) {
    console.log('error occured:' + error);
    return throwError(error);
  }

  uploadFile(formdata: any) {
    return this.http
      .post(this.uploadUrl, formdata)
      .pipe(catchError(this._errorHandler));
  }

  seeLogin() {
    this.loggedIn.next(false);
  }
  userLogedin() {
    this.loggedIn.next(true);
  }

  chnBtnStatus() {
    this.enableUploadBtn.next(true);
  }

  registerUser(nuser: newUser) {
    const bodyparm = new HttpParams()
      .set('client', nuser.client)
      .set('profession', nuser.profession)
      .set('pass', nuser.pass)
      .set('emailid', nuser.emailid)
      .set('mobile', nuser.mobile);

    if (nuser.emailid !== '' && nuser.pass != '') {
      // {3}

      return this.http
        .post(this.registerUserUrl, bodyparm)
        .pipe(map((res: any) => res));
    }
    // return false
  }

  editUser(euser: editUser) {
    const bodyparm = new HttpParams()
      .set('client', euser.client)
      .set('profession', euser.prof)
      .set('pass', euser.pass)
      .set('emailid', euser.emailid)
      .set('mobile', euser.mobile)
      .set('user_id', this.editClientNew ? this.editClientNew : '');

    return this.http
      .post(this.editUserUrl, bodyparm)
      .pipe(map((res: any) => res));
  }

  getEditUserDetails() {
    const bodyparm = new HttpParams().set(
      'user_id',
      this.editClientNew ? this.editClientNew : ''
    );
    return this.http
      .post(this.editUserDetailsUrl, bodyparm)
      .pipe(map((res: any) => res));
  }

  addProject(nuproj: newProject) {
    const bodyparm = new HttpParams()
      .set('user_id', this.newEventId ? this.newEventId : '')
      .set('proj_name', nuproj.project);

    return this.http
      .post(this.addproject, bodyparm)
      .pipe(map((res: any) => res));
  }

  modelValues() {
    

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else if (this.newEmail == 'demo@ecomatrix.io') {
      this.condId = '5';
      this.newProjId = this.demoprjId;
    } else {
      this.condId = this.newUserId;
    }

    const param = new HttpParams()
      .set('user_id', this.condId ? this.condId : '')
      .set('proj_id', this.newProjId);
    return this.http.post(this.newurl, param).pipe(map((res: any) => res));
  }

  proEnergy() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    var w1 = '"' + 'W1' + '"';
    var r1 = '"' + 'R1' + '"';
    var f1 = '"' + 'F1' + '"';
    var win1 = '"' + 'WIN01' + '"';
    var f1 = '"' + 'F1' + '"';
    var sh = '"' + 'NO' + '"';
    var lg = '"' + 'LPD1' + '"';
    var wwr = '"' + '0.15' + '"';
    var dl = '"' + 'DLOFF' + '"';

    const param = new HttpParams()
      .set('user_id', this.condId ? this.condId : '')
      .set('proj_id', this.newProjId)
      .set('wall', w1)
      .set('roof', r1)
      .set('floor', f1)
      .set('window', win1)
      .set('shading', sh)
      .set('lighting', lg)
      .set('wwr', wwr)
      .set('dl', dl);
    return this.http
      .post(this.proEnergyUrl, param)
      .pipe(map((res: any) => res));
  }

  freshAirList() {
   

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http
      .post(this.freshAirUrlNew, param)
      .pipe(map((res: any) => res));
  }

  proSankey() {
    this.currentMesgcellSevenMsg.subscribe(
      (cellSevenmessage: any) => (this.cellSevenmessage = cellSevenmessage)
    );

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
   
    var w1 = this.cellmessage;
    var r1 = this.cellTwomessage;
    var f1 = this.cellThreemessage;
    var win1 = this.cellFourmessage;

    var sh = this.cellFivemessage;
    var lg = this.cellSixmessage;
    var ht = this.celltenmessage;
	  var hvac = this.cellNinemessage;
    var cid = this.combIdSelmessage;

   /* if (w1 == 'dgt msg') {
      var w1: any = '"' + this.wallone + '"';
      var r1: any = '"' + this.roofone + '"';
      var f1: any = '"' + this.florone + '"';
      var win1: any = '"' + this.windone + '"';
      //  var f1 = '"'+ 'F1' + '"';
      var sh: any = '"' + this.shadone + '"';
      var lg: any = '"' + this.ligtone + '"';
      //var cid: any = this.combId;
      var ht: any = this.heatone;
    }*/

    

    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }

    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj)
      .set('cID', cid)
      .set('heatRec', ht)
	  .set('hvac', hvac);
    return this.http.post(this.proSankUrl, param).pipe(map((res: any) => res));
  }

  dropDownValues() {
    return this.http.get(this.clientlist).pipe(map((res: any) => res));
  }

  projectValues() {
    return this.http
      .get(this.project + this.newUserId)
      .pipe(map((res: any) => res));
  }

  renewablesData() {
   

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http
      .post(this.renewablesUrl, param)
      .pipe(map((res: any) => res));
  }

  renewablesCostData() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http
      .post(this.renewablesCostUrl, param)
      .pipe(map((res: any) => res));
  }
  wizardSelectionData() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http
      .post(this.wizardSelectionDataUrl, param)
      .pipe(map((res: any) => res));
  }

  buildingEnvData() {
   
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http.post(this.buildenv, param).pipe(map((res: any) => res));
  }

  buildingEnvCostData() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http
      .post(this.buildEnvCostUrl, param)
      .pipe(map((res: any) => res));
  }
  lightingData() {
    

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http.post(this.lighting, param).pipe(map((res: any) => res));
  }

  lightingCostData() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http
      .post(this.lightingCostUrl, param)
      .pipe(map((res: any) => res));
  }

  infiltrationData() {
    

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http.post(this.inf, param).pipe(map((res: any) => res));
  }

  infCostData() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http.post(this.infCostUrl, param).pipe(map((res: any) => res));
  }

  hvacData() {
    
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http.post(this.hvac, param).pipe(map((res: any) => res));
  }

  hvacCostData() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http.post(this.hvacUrl, param).pipe(map((res: any) => res));
  }

  freshAirData() {
    
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http.post(this.freshAirUrl, param).pipe(map((res: any) => res));
  }

  checkUpdateStatus() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }

    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http
      .post(this.checkUpdateStatusUrl, param)
      .pipe(map((res: any) => res));
  }
  opCostData() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);

    return this.http.post(this.kpiDataUrl, param).pipe(map((res: any) => res));
  }
  tediOptionsData() {
	if (this.newEmail == 'anuprathi1@gmail.com') {
	  this.condId = this.newEventId;
	} else {
	  this.condId = this.newUserId;
	}
	if (this.newEmail == 'demo@ecomatrix.io') {
	  var userDemo: any = '5';
	  var userProj: any = this.demoprjId;
	} else {
	  var userDemo: any = this.condId;
	  var userProj: any = this.newProjId;
	}
	const param = new HttpParams()
	  .set('user_id', userDemo)
	  .set('proj_id', userProj);

	return this.http.post(this.tediOptionsDataUrl, param).pipe(map((res: any) => res));
  }
  categoryCustomizationData() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var userDemo: any = '5';
      var userProj: any = this.demoprjId;
    } else {
      var userDemo: any = this.condId;
      var userProj: any = this.newProjId;
    }
    const param = new HttpParams()
      .set('user_id', userDemo)
      .set('proj_id', userProj);
  
    return this.http.post(this.catCustomDataUrl, param).pipe(map((res: any) => res));
  }
  humidificationData() {
	if (this.newEmail == 'anuprathi1@gmail.com') {
	  this.condId = this.newEventId;
	} else {
	  this.condId = this.newUserId;
	}
	if (this.newEmail == 'demo@ecomatrix.io') {
	  var userDemo: any = '5';
	  var userProj: any = this.demoprjId;
	} else {
	  var userDemo: any = this.condId;
	  var userProj: any = this.newProjId;
	}
	const param = new HttpParams()
	  .set('user_id', userDemo)
	  .set('proj_id', userProj);

	return this.http.post(this.humDataUrl, param).pipe(map((res: any) => res));
  }
  baselineDefnData() {
	if (this.newEmail == 'anuprathi1@gmail.com') {
	  this.condId = this.newEventId;
	} else {
	  this.condId = this.newUserId;
	}
	if (this.newEmail == 'demo@ecomatrix.io') {
	  var userDemo: any = '5';
	  var userProj: any = this.demoprjId;
	} else {
	  var userDemo: any = this.condId;
	  var userProj: any = this.newProjId;
	}
	const param = new HttpParams()
	  .set('user_id', userDemo)
	  .set('proj_id', userProj);

	return this.http.post(this.baselineDefnDataUrl, param).pipe(map((res: any) => res));
  }
  logout() {
    // {4}
    this.loggedIn.next(false);
    this.router.navigate(['/']);
  }
}
